export default "__VITE_ASSET__Cd1vzBXC__"